@if (highlightItemsConfig$ | async; as highlightItemsConfig) {
  @if (visibleItemsConfig$ | async; as visibleItemsConfig) {
    <dcr-app-shell>
      @if (config.header && visibleItemsConfig.showHeader) {
        <header slot="header">
          <router-outlet name="header"></router-outlet>
        </header>
      }
      @if (config.navigationRail && visibleItemsConfig.showNavigationRail) {
        <nav slot="navigation-rail">
          <router-outlet name="navigation-rail"></router-outlet>
        </nav>
      }
      @if (config.mobileNavigationRail || config.mobileNavigationDrawer) {
        <nav
          class="mobile-menu"
          [class.open]="openMenu$ | async"
          >
          @if (config.mobileNavigationRail && visibleItemsConfig.showNavigationRail) {
            <div class="rail h-full max-h-full">
              <router-outlet name="navigation-rail"></router-outlet>
            </div>
          }
          @if (config.mobileNavigationDrawer && visibleItemsConfig.showNavigationDrawer) {
            <div class="drawer">
              <router-outlet name="navigation-drawer"></router-outlet>
            </div>
          }
        </nav>
      }
      @if ((config.mobileNavigationRail || config.mobileNavigationDrawer) && openMenu$ | async) {
        <div
          class="scrim"
          (click)="closeMenu()"
          @fadeIn
        ></div>
      }
      @if (config.navigationDrawer && visibleItemsConfig.showNavigationDrawer) {
        <nav
          slot="navigation-drawer"
          [ngClass]="{ 'tablet-drawer': (isTablet$ | async) }"
          >
          <router-outlet name="navigation-drawer"></router-outlet>
        </nav>
      }
      @if (config.pageHeader && visibleItemsConfig.showPageHeader) {
        <div
          slot="page-header"
          [class.p-is-2xl]="config.mobileNavigationRail && config.mobileNavigationDrawer"
          >
          <router-outlet name="page-header"></router-outlet>
        </div>
      }
      <router-outlet></router-outlet>
      @if (config.pageFooter && visibleItemsConfig.showPageFooter) {
        <div slot="page-footer">
          <router-outlet name="page-footer"></router-outlet>
        </div>
      }
      @if (config.mobileSideSheet) {
        <div class="mobile-side-sheet" [class.open]="visibleItemsConfig.showSideSheet">
          <router-outlet name="side-sheet"></router-outlet>
        </div>
      }
      @if (config.mobileSideSheet && visibleItemsConfig.showSideSheet) {
        <div
          class="transparent-scrim"
          (click)="closeSideSheet()"
          @fadeIn
        ></div>
      }
      @if (config.sideSheet && visibleItemsConfig.showSideSheet && !config.mobileSideSheet) {
        <div
          slot="side-sheet"
          [class.animate-highlight]="highlightItemsConfig.highlightSideSheet"
          >
          <router-outlet name="side-sheet"></router-outlet>
        </div>
      }
      @if (config.footer && visibleItemsConfig.showFooter) {
        <footer slot="footer">
          <router-outlet name="footer"></router-outlet>
        </footer>
      }
    </dcr-app-shell>
  }
}
